
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { quizPlayerEventBus } from '@/main';
import { List, Enumerable } from 'linq-collections';
// Interfaces
import { ExChoiceListItemVm, ExChoiceList, ElementSaveStateVm } from '@/interfaces/ExDataSet';
import { ExerciseVM } from "@/interfaces/ExerciseVM";

const globals = namespace("globals");
const quizplayerstore = namespace("quizplayerstore");

@Component({
  components: {
  }
})
export default class CompSelect extends Vue {
  @Prop() guid!: string;
  @Prop() choiceList!: ExChoiceList;
  @Prop() finalized!: boolean;
  @Prop() preset!: boolean;
  @Prop() text!: string;
  @Prop() textArray!: string[];
  @Prop() size!: string; // 24, evtl.: x-small, small, medium, large, x-large
  @Prop() color!: string;
  @Prop() weight!: string; // lighter, normal, bold, bolder, 100,200,300,400,500,600,700,800,900
  @Prop() fontStyle!: string; // normal, italic, oblique

  @quizplayerstore.Action setElementState!: (saveState: ElementSaveStateVm) => void;
  @quizplayerstore.Action getElementState!: (settings: string) => Promise<string | null>;
  @globals.Getter selectedExercise!: ExerciseVM | null;

  // SingleChoice
  radioGroup: ExChoiceListItemVm | null = null;

  // isMultipleChoice = false;
  isChecked = false;
  selectedChoice: ExChoiceListItemVm | null = null;
  showSuccessCheck: boolean = false;
  showFailedCheck: boolean = false;
  rightAnswer: string | null = null;

  $refs!: {
    radioButton: any;
  };

  async mounted() {
    if (this.choiceList.items) {
      // Try to load existing state for this element
      let saveState = await this.getElementState(this.guid);
      if (saveState) {
        // Apply the loaded settings
        const selectedId = JSON.parse(saveState);
        // The selected property of choice list items will be ignored. Use this.selectedChoice instead.
        // this.choiceList.items?.forEach(item => {
        //   item.selected = selectedIds.includes(item.id);
        // });
        this.selectedChoice = new List(this.choiceList.items).singleOrDefault(x => x.id === selectedId) ?? null;
      }

      this.rightAnswer = new List(this.choiceList.items).singleOrDefault(x => x.isRight)?.label ?? null;
      if (!saveState && this.preset) {
        this.selectedChoice = new List(this.choiceList.items).firstOrDefault() ?? null;
      }

      if (saveState || this.preset) {
        // this.$emit("changed:CompSelect", this.choiceList.id, this.selectedChoice!.isRight);
        this.$store.commit("quizplayerstore/setChoiceState",
          { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: this.selectedChoice!.isRight, selectionLable: this.selectedChoice!.label }
        );
        quizPlayerEventBus.$emit("changed:score", { questionId: this.choiceList.questionId, score: this.selectedChoice!.isRight ? 100 : 0 });
      }

      // Randomize the order of the choices
      if ((this.selectedExercise?.randomizeQuestionOptions ?? false) && !this.choiceList.isMultipleChoice) {
        // console.log("Randomizing choices for single choice or select box");
        this.choiceList.items = new List(this.choiceList.items).orderBy(x => Math.random()).toArray();
      }

      if (saveState) {
        await this.$globalHelper.delay(); // Give the verify button time to appear
        quizPlayerEventBus.$emit("verify", true);
      }

      // focus the first single choice using the generic focusChoice helper
      // if (this.choiceList.isSingleChoice) {
      //   // Ensure DOM is updated and then focus the first choice
      //   await this.$globalHelper.delay(300);
      //   this.focusSingleChoiceItem(0);
      // }
    }
  }

  handleKeyNavigation(event: KeyboardEvent, currentIndex: number) {
    if (!this.choiceList?.items || this.choiceList.items.length === 0) return;

    let targetIndex = -1;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        event.preventDefault();
        targetIndex = currentIndex + 1;
        if (targetIndex >= this.choiceList.items.length) {
          targetIndex = 0; // Wrap to first item
        }
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        event.preventDefault();
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) {
          targetIndex = this.choiceList.items.length - 1; // Wrap to last item
        }
        break;

      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;

      case 'End':
        event.preventDefault();
        targetIndex = this.choiceList.items.length - 1;
        break;

      default:
        return; // Don't handle other keys
    }

    // Focus the target item
    this.focusSingleChoiceItem(targetIndex);
  }

  focusSingleChoiceItem(index: number) {
    const listItems = this.$el.querySelectorAll('.dc-choice');
    // console.log("focusListItem: index=", index, " listItems.length=", listItems.length);
    if (listItems[index]) {
      (listItems[index] as HTMLElement).focus();
    }
  }

  // Fokus auf eine bestimmte Choice-Index setzen (robust für Vue-Komponenten oder HTMLElements)
  // focusChoice(index: number) {
  //   const arr = this.$refs.singleChoices as any[] | undefined;
  //   if (!arr || !arr.length) {
  //     return;
  //   }
  //   console.log("focusChoice: index=", index, " arr.length=", arr.length);

  //   if (index < 0 || index >= arr.length) {
  //     // out of bounds: ignore
  //     return;
  //   }

  //   const target = arr[index];
  //   if (!target) return;

  //   // If Vue component instance, try its $el
  //   if (target.$el && typeof target.$el.focus === "function") {
  //     try { (target.$el as HTMLElement).focus(); return; } catch { /* ignore */ }
  //   }

  //   // If raw HTMLElement
  //   // if (typeof (target as any).focus === "function") {
  //   //   try { (target as any).focus(); return; } catch { /* ignore */ }
  //   // }

  //   // last resort: find a focusable descendant
  //   // try {
  //   //   const el = target.$el ? (target.$el as HTMLElement) : (target as HTMLElement);
  //   //   const focusable = el && el.querySelector ? el.querySelector<HTMLElement>('[tabindex], button, a, input, textarea') : null;
  //   //   if (focusable) focusable.focus();
  //   // } catch { /* ignore */ }
  // }

  @Watch("finalized")
  onFinalizedChanged(val: boolean) {
    // Do not save state if scoring is required. So the question can be re-answered.
    if (this.selectedExercise?.requiredScoreValue ?? 0 > 0) {
      console.log("Not saving state because scoring is required.");
      return;
    }

    if (val) {
      this.setElementState( {
          guid: this.guid,
          settings: JSON.stringify(this.selectedChoice?.id)
        } as ElementSaveStateVm
      );
    }
  }

  get statusMessage() {
    if (!this.finalized) {
      return "";
    }

    // Multiple Choice feedback
    if (this.choiceList.isMultipleChoice && this.selectedChoice) {
      if (this.selectedChoice.isRight && this.isChecked) {
        return `Richtig! ${this.hyperText || 'Die Auswahl'} ist korrekt.`;
      // } else if (this.selectedChoice.isRight && !this.isChecked) {
      //   return `Richtig! ${this.hyperText || 'Diese Antwort'} ist nicht ausgewählt worden.`;
      } else if (!this.selectedChoice.isRight && this.isChecked) {
        return `Falsch! ${this.hyperText || 'Die Auswahl'} hätte nicht ausgewählt werden sollen.`;
      } else if (!this.selectedChoice.isRight && !this.isChecked) {
        return `Falsch! ${this.hyperText || 'Die Auswahl'} hätte ausgewählt werden sollen.`;
      }
    }

    // Single Choice feedback
    if (this.choiceList.isSingleChoice && this.choiceList.items) {
      const correctAnswer = new List(this.choiceList.items).singleOrDefault(x => x.isRight);
      const selectedAnswer = this.selectedChoice;

      if (correctAnswer && selectedAnswer) {
        if (selectedAnswer.isRight) {
          return `Richtig! ${selectedAnswer.label} ist die korrekte Antwort.`;
        } else {
          return `Falsch! ${selectedAnswer.label} ist nicht korrekt. Die richtige Antwort ist: ${correctAnswer.label}`;
        }
      } else if (correctAnswer && !selectedAnswer) {
        return `Keine Antwort ausgewählt. Die richtige Antwort ist: ${correctAnswer.label}`;
      }
    }

    // Dropdown feedback
    if (!this.choiceList.isSingleChoice && !this.choiceList.isMultipleChoice && this.selectedChoice) {
      if (this.selectedChoice.isRight) {
        return `Richtig! ${this.selectedChoice.label} ist korrekt.`;
      } else {
        return `Falsch! ${this.selectedChoice.label} ist nicht korrekt. Die richtige Antwort ist: ${this.rightAnswer}`;
      }
    }

    return "";
  }

  // Event from select box or single choice radio buttons
  async onChanged() {
    if (this.choiceList.isSingleChoice) {
      this.selectedChoice = this.radioGroup;
    }

    if (!this.selectedChoice)
      return;

    // console.log("emit change event: ", this.selectedChoice.isRight);
    await this.$store.commit("quizplayerstore/setChoiceState",
      { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: this.selectedChoice.isRight, selectionLable: this.selectedChoice.label }
    );
    await quizPlayerEventBus.$emit("changed:score",
      { questionId: this.choiceList.questionId, score: this.selectedChoice.isRight ? 100 : 0 });
  }

  onRadioItemClicked(item: ExChoiceListItemVm, index: number) {
    if (this.finalized) return;
    // console.log("onRadioItemClicked: ", item);

    this.radioGroup = item;

    // restore focus to the clicked choice (if index provided)
    if (this.choiceList.isSingleChoice && typeof index === "number") {
      // slight delay ensures DOM updates finished
      this.$nextTick(() => {
        this.focusSingleChoiceItem(index!);
      });
    }

    this.onChanged();
  }

  onItemClicked() {
    if (this.finalized) return;

    this.isChecked = !this.isChecked;
    this.selectedChoice = new List(this.choiceList.items!).singleOrDefault(x => x.label == (this.isChecked ? "true" : "false"))!;
    console.log("onItemClicked. Set selectedChoice: ", this.selectedChoice);

    this.$store.commit("quizplayerstore/setChoiceState",
      { id: this.choiceList.id, questionId: this.choiceList.questionId, isRight: this.selectedChoice.isRight, selectionLable: this.selectedChoice.label }
    );
    quizPlayerEventBus.$emit("changed:score", { questionId: this.choiceList.questionId, score: this.selectedChoice.isRight ? 100 : 0 });
  }

  get fontSize() {
    if (this.size == null)
      return "18px";
    if (isNaN(Number(this.size))) // Number(this.size) != NaN)
      return this.size;
    return this.size + "px";
  }

  get lineHeight() {
    let fs = this.fontSize.replace("px", "");
    if (isNaN(Number(fs)))
      return this.fontSize;

    return Number(fs) + 2 + "px";
  }

  get hyperText() {
    if (this.text != null)
      return this.text;
    if (this.textArray != null)
      return this.textArray.join('');

    return null;
  }

  get backgroundColor() {
    if (this.$vuetify.theme.dark) {
      return "#ffffff30";

      // if (!this.finalized)
      //   return "#ffffff30";
      // if (this.selectedChoice?.isRight)
      //   return "#00ff0020";
      // return "#ff000025";
    }

    return "#ffffff80";

    // if (!this.finalized)
    //   return "#ffffff80";
    // if (this.selectedChoice?.isRight)
    //   return "#00ff0020";
    // return "#ff000025";
  }

  get borderStyle() {
    if (!this.finalized)
      return "width: 100%;";
    if (!this.selectedChoice?.isRight)
      return "border: 2px solid #f4433680; width: calc(100% - 32px);";
    if (this.selectedChoice?.isRight && this.isChecked)
      return "border: 2px solid #00b00080; width: calc(100% - 32px);";
    return "width: calc(100% - 32px);";
  }

  getRadioButtonBorderStyle(item: ExChoiceListItemVm) {
    if (!this.finalized)
      return "width: 100%;";

    // Right
    if (item.isRight)
      return "border: 2px solid #00b00080; width: calc(100% - 34px);";
    // Wrong
    if (this.choiceList.selectionLable == item.label && !this.selectedChoice?.isRight)
      return "border: 2px solid #f4433680; width: calc(100% - 34px);";
    return "width: calc(100% - 34px);";
  }

  get checkBoxColor() {
    if (this.$vuetify.theme.dark)
      return "#ffffff";

    return "#000000a0";
  }
}
